export enum QuestionType {
  Freeform = 1,
  Checkbox = 2,
  Radio = 3,
  CheckboxFreeform = 4,
  RadioFreeform = 5
}
